import React from 'react'
import whatsApp from 'assets/icons/whatsapp.svg'

function WhatsApp() {
  const message = 'Olá, Vim pelo site e gostaria de saber mais sobre seus serviços.'
  const phoneNumber = '5543988634741'
  const whatsAppLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`

  return (
    <a
      href={whatsAppLink}
      className='fixed bottom-4 right-4 transition-all duration-500 hover:scale-110'
      target='_blank'
    >
      <picture>
        <img src={whatsApp} alt='WhatsApp' loading='lazy' />
      </picture>
    </a>
  )
}

export default WhatsApp
